import _debounce from "lodash-es/debounce";
import Cookies from "js-cookie";
import { ElMessage } from "element-plus";
import get from "lodash-es/get";
import _isArray from "lodash-es/isArray";
import _isObject from "lodash-es/isObject";
import isEmpty from "lodash-es/isEmpty";
import BigNumber from "bignumber.js";
import { axiosClient, axiosNuxt } from "~/common/js/axios";
import {
  insertSignToParams,
  isLoginedToken,
  filterFalsityParams,
} from "~/common/js/utils";
import { transLang } from '~/common/js/storeUtil';
import {
  TRADE_ORDER_TYPE_ENUM,
  // ENTRUST_STATE,
  ORDER_TRADE_TYPE_ENUM,
  ORDER_TRADE_PLAN_TYPE_ENUM,
  unPriceList,
  ORDER_TRADE_TAB_ENUM,
  PRO_TRADE_MODE_ENUM,
  BASIC_TRADE_MODE_ENUM,
  TRADE_PAGE_LAYOUT,
  OLD_LOCALES_OBJ_REVERSE,
} from "~/common/js/const";
import { WORKER_MSG_TOPIC } from "~/common/js/workerConfig";
import { defineStore } from "pinia";
import { useAccountStore } from "./account";
import { useIndexStore } from "./index";

// 延迟500ms拉取数据(300ms不够)，ws数据推送非常及时，担是服务端数据落库更新很忙，所以要延迟一点请求
// 暂定500，但即使500，也会有大概率发生数据更新延迟，但说是线上能改善
// 同步一下和产品和后端的沟通
// 历史委托里数据更新有延迟为“合理”
// 当前委托如果数据更新有延迟，及时反馈
const wsTimeout = 500;
// 委托请求时的延迟时间
const pendingTimeout = 300;
// 防抖动延迟时间
const debounceTimeout = 800;

let privateList = [];

let openOrdersOri = []; // 为了 lastPid
let historyOrdersOri = []; // 为了 lastPid


const symbolFn = (state) => {
  if (!state.symbolList) {
    return;
  }
  const symbolEntity = state.symbolById[String(state.symbolInfo.symbolId)];
  if (!symbolEntity || !symbolEntity?.name) {
    return;
  }
  const [prefixName, suffixName] = symbolEntity.name.split("/");
  state.symbolInfo = Object.assign({}, state.symbolInfo, symbolEntity, {
    symbolFullName: symbolEntity.name,
    symbolSubName: prefixName,
    symbolMainName: suffixName, // 动态交易区后这么判断
  }); // 一大堆有的没的币种信息
};


let walletFn;
let walletLocale;
let walletSymbol;


// spot-map 更新允许更新时间 10min
const MAX_SPOT_MAP_CACHE_TIME = 10 * 60 * 1000;



export const useTradeStore = defineStore("trade", {
  state: () => ({
    subPriceLang: null,
    symbolInfo: {
      coinType: null, // example: ETH 16
      symbolId: 53,
      symbolFullName: null, // BMX/ETH
      symbolMainName: null, // ETH
      symbolSubName: null, // BMX
      priceScale: null, // 1000001
      depthEndPrecision: null, // 最大精度 废弃
      depthStartPrecision: null, // 最小精度 废弃

      precisionList: [], // orderbook 精度 列表
      currentPrecision: null, // orderbook 当前精度
      feeRateType: null, // 交易对类型 0 B类 1 A类

      pricePrecision: null,
      countPrecision: null,
      // @deprecated: use getter: getUpState
      upState: true,
      // marketCoinId: null, // 计价币Id
    },
    // @perf: 额外维护一个 upState 的 map 是划算的
    upStateMap: {},
    currentSymbolWallet: {
      walletVO1: {
        availableBalance: 0,
      },
      walletVO2: {
        availableBalance: 0,
      },
    }, // 币种用户余额，Objct

    //币种查询信息
    coinInfo: {
      title: null,
      subtitle: null,
      issueDate: null,
      issuePrice: null,
      circulating: null,
      totalSupply: null,
      website: null,
      whitepaper: null,
      projectDetail: null,
      projectInformation: null,
      projectAnticipation: null,
      projectEvaluation: null,
      pdfUrl: null,
      cmcUrl: null,

      hasInfo: true,
      hasEvaluation: true,

      hasRating: true,
      ratingScore: null,
      hypeScore: null,
      techScore: null,
      teamScore: null,
    },

    // 订单的tab类型
    orderTradeTab: ORDER_TRADE_TAB_ENUM.OPEN_ORDERS,
    // 订单交易类型
    orderTradeType: ORDER_TRADE_TYPE_ENUM.SPOT_MARKET,
    // 订单交易类型
    orderTradePlanType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_MARKET,
    // 未来可能还有别的类型计数，所以用一个对象来组织
    currentOrderCounter: {
      [ORDER_TRADE_TYPE_ENUM.SPOT_MARKET]: 0,
      [ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER]: 0,
      [ORDER_TRADE_TYPE_ENUM.SPOT_STOP]: 0,
    },
    // 杠杆仓位数量计数
    marginAssetsPositionsCounter: 0,
    /**
     * 当前委托
     */
    currentOrder: {
      data: [],
      pending: false,
      pendingTimeoutID: null,
      config: {
        pageIndex: 1,
        pageSize: 15,
      },
    },
    /**
     * 历史委托
     */
    historyOrder: {
      data: [],
      pending: false,
      pendingTimeoutID: null,

      config: {
        pageIndex: 1,
        pageSize: 15,
      },
    },
    /**
     * 成交历史
     */
    completeOrder: {
      data: [],
      pending: false,
      config: {
        pageIndex: 1,
        pageSize: 15,
      },
    },
    /**
     * 资金列表
     */
    assetsFundsList: {
      data: [],
      dataMap: {}, // map形式
      pending: false,
      pendingTimeoutID: null,
      config: {},
    },

    /**
     * 仓位列表
     */
    assetsPositionsList: {
      data: [],
      dataMap: {}, // map形式
      pending: false,
      pendingTimeoutID: null,
      config: {},
    },

    // 委托单数据
    orderList: {
      fentrustVOS: null,
    },
    currentPage: 1, // 当前委托单页面
    orderHistoryList: null, //历史委托单数据
    orderCompeletedList: null, // 成交记录

    symbolList: null, // 所有交易队信息
    symbolById: {},
    /**
     * 所有订阅实时价格的交易对信息
     * 结构是{ 2526: { symbol: 2526, c: xxx, h: xxx, increase: xxx } },
     * 2526 是交易对id
     * c 是最新成交价，h 是24小时最高价，increase 是涨幅等，具体参考后端接口文档
     * 这里只有当前订阅的交易对信息，没有订阅的不会在这个对象里
     *  */
    subscribePriceSymbolInfo: {},

    hadSubscribedPrice: false, // 是否订阅了所有交易对价格

    /**
     * 交易类型
     */
    orderType: TRADE_ORDER_TYPE_ENUM.LIMIT,
    buyPrice: null,
    buyAmount: null,
    sellPrice: null,
    sellAmount: null,
    topOrderType: null, //最新成交的类型， 吃单或者做单

    isVip: false, //
    isCountdowning: false,
    countMs: 0,
    upTime: 0,

    isAllPair: true, // 是否全部, 默认全部

    pendingOrderCount: {
      // needReset: true, // 当前挂单簿单位，是否需要重置设置
      len: 0, // 剪切长度
      unit: "", // 当前挂单簿单位
    },

    marketTradeCount: {
      // needReset: true, // 当前市场交易单位，是否需要重置设置
      len: 0, // 剪切长度
      unit: "", // 当前市场交易单位
    },
    // 交易页面显示手续费白名单
    feeWhiteList: [],

    // 2088 隐私币 列表
    coinInvisibleList: [],
    // 为什么不跟privateSymbolList一样是id数组？ coinName 也要，预防后端只给name，比如 费率一些地方之类
    privateCoinList: [], // [{coinId: 2, coinName: 'BTC', countries: [XXX]}]
    // 2088 隐私交易对列表，根据隐私币 前端生成
    privateSymbolList: [], // [53,1038]
    // 专业版当前选中的是杠杆还是现货
    proTradeMode: PRO_TRADE_MODE_ENUM.SPOT,
    basicTradeMode: BASIC_TRADE_MODE_ENUM.SPOT,
    // 当前页面类型：BASIC=基础版,PRO=专业版
    tradePageLayout: TRADE_PAGE_LAYOUT.BASIC,
    spotMapUpdateTime: null,
  }),
  getters: {
    getIsLoginedFromIndex(){
      const indexStore = useIndexStore()
      return indexStore.isLogined
    },
    getLocaleFromIndex(){
      const indexStore = useIndexStore()
      return indexStore.locale
    },
    getterPrivateCoinList: (state) => {
      const accountStore = useAccountStore();
      // 用户所属地区未准备好
      if (!accountStore.country) {
        return [];
      }
      return state.coinInvisibleList.filter((item) => {
        return item.countrys?.includes(window.currentCountryCode); //
      });
    },
    getterPrivateSymbolList (state) {
      // 开始处理现货交易对 symbolList symbolById
      if (!state.symbolList || isEmpty(state.symbolById)) {
        return [];
      }
      const privateSymbolList = [];
      this.getterPrivateCoinList.forEach((priItem) => {
        const coinId = priItem.coinId;
        const keys = Object.keys(state.symbolById);

        keys.forEach((symbolId) => {
          if (+coinId === 1992 && +state.symbolById[symbolId].coinId === 1992) {
            // console.log('+state.symbolById[symbolId].coinId', +state.symbolById[symbolId].coinId, symbolId)
          }

          if (
            // 买卖币或者计价币
            (+state.symbolById[symbolId].coinId === +coinId ||
              +state.symbolById[symbolId].marketCoinId === +coinId) &&
            !privateSymbolList.includes(+symbolId)
          ) {
            privateSymbolList.push(+symbolId);
          }
        });
      });

      return privateSymbolList;
    },
    // 原来叫 getUpState，但是在pina中的调用都是是用this., 所以state、gettet、action名称不能重复
    upState: (state) => state.upStateMap[state.symbolInfo.symbol],
    currentOrderTotalCounter: (state) => {
      return Object.keys(state.currentOrderCounter).reduce((total, key) => {
        total += state.currentOrderCounter[key] || 0;
        return total;
      }, 0);
    },
    symbolListExcludePrivate: (state) => {
      let symbolTemp = state.symbolList;
      const tempArr = [];
      symbolTemp.forEach((item) => {
        if (!item) {
          return;
        }
        const tempIds = [];
        const tempObj = { ...item };
        item.mappingIds.forEach((sid) => {
          if (!state.privateSymbolList.includes(+sid)) {
            tempIds.push(+sid);
          }
        });
        tempObj.mappingIds = tempIds;
        tempArr.push(tempObj);
      });
      return tempArr;
    },
    symbolByIdExcludePrivate: (state) => {
      const privateSymbolList = state.privateSymbolList;
      const tempObj = { ...state.symbolById };
      privateSymbolList.forEach((sid) => {
        delete tempObj[sid];
      });
      return tempObj;
    },
    symbolNeedUpdate(state) {
      if (!Array.isArray(state.symbolList) || state.symbolList.length === 0)
        return true;
      if (Date.now() - state.spotMapUpdateTime > MAX_SPOT_MAP_CACHE_TIME) {
        return true;
      }
      return false;
    },
  },
  actions: {
    // 初始化
    SET_SYMBOLID(id) {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }
      // console.time('SET_SYMBOLID');
      this.symbolInfo.symbolId = +id;
      this.symbolInfo.symbol = id;
      const symbolEntity = this.symbolById[String(id)];
      // console.timeLog('SET_SYMBOLID');
      if (symbolEntity) {
        const keysArr = Object.keys(symbolEntity.quotationPriceMap);

        keysArr.sort((a, b) => {
          if (+a > +b) {
            return -1;
          } else {
            return 1;
          }
        });
        const tempArr = [];
        keysArr.forEach((keyStr) => {
          const obj = {
            val: keyStr,
            desc: symbolEntity.quotationPriceMap[keyStr],
          };
          tempArr.push(obj);
        });
        // 默认最高深度
        this.symbolInfo.currentPrecision = tempArr[0];
        this.symbolInfo.precisionList = tempArr;
      }
      symbolFn(state);
      // console.timeEnd('SET_SYMBOLID');
    },
    SET_SYMBOL_PRECISION(data) {
      this.symbolInfo.currentPrecision = data;
    },
    // SET_SYMBOL_LIST(data) {
    //   console.time('SET_SYMBOL_LIST')
    //   this.symbolList = data.map((group) => {
    //     const { mappingList, coinName, coinType, ...others } = group
    //     mappingList.forEach((entity) => {
    //       Vue.set(this.symbolById, String(entity.symbol), Object.assign(entity, {
    //         coinName,
    //         coinType,
    //       }))
    //       // 临时方案：从mappingList中查找BTC/USDT交易对，获取人民币的汇率
    //       if (entity.name === 'BTC/USDT') {
    //         const exchangeRate = entity.rate / entity.c
    //         this.exchangeRate[entity.sign] = exchangeRate
    //       }
    //     })
    //     return Object.assign(others, {
    //       coinName,
    //       coinType,
    //       // perf: disable getter & setter binding
    //       mappingIds: Object.freeze(mappingList.map((d) => d.symbol)),
    //     })
    //   })

    //   symbolFn(state)
    //   console.timeEnd('SET_SYMBOL_LIST')
    // },
    SET_SYMBOL_LIST(data) {
      // console.log('SET_SYMBOL_LIST')
      // console.time('SET_SYMBOL_LIST')
      const symbolById = {};
      this.symbolList = data.map((group) => {
        const { mappingList, coinName, coinType, ...others } = group;
        mappingList.forEach((entity) => {
          Object.assign(symbolById, {
            // @perf: 这里冻结交易对详情的性能收益是巨大的
            [entity.symbol]: Object.freeze(
              Object.assign(entity, {
                coinName,
                coinType,
              })
            ),
          });

          Object.assign(this.upStateMap, {
            [entity.symbol]: entity.upState,
          });
        });
        return Object.assign(others, {
          coinName,
          coinType,
          mappingIds: Object.freeze(mappingList.map((d) => d.symbol)),
        });
      });
      this.symbolById = symbolById;
      this.spotMapUpdateTime = Date.now();
      symbolFn(state);
      // console.timeEnd('SET_SYMBOL_LIST')
    },
    CHANGE_SYMBOL_INFO(updatedList) {
      // console.time('CHANGE_SYMBOL_INFO');
      if (!this.symbolList || this.symbolList.length === 0) {
        //console.log('no trade pair')
        return;
      }
      // console.time('CHANGE_SYMBOL_INFO');
      const currentSymbolId = this.symbolInfo.symbolId;
      let needUpdateSymbolInfo;
      let subscribePriceInfo = {};
      // console.log('updatedList', updatedList.length, new Set(updatedList.map(d => d.symbolId)))
      updatedList.forEach(({ data, symbolId }) => {
        // @perf: 交易对具体信息可以冻结
        this.symbolById[symbolId] = Object.freeze({
          ...this.symbolById[symbolId],
          ...data,
        });
        if (currentSymbolId === symbolId) {
          needUpdateSymbolInfo = data;
        }
        // 更新价格订阅对象
        subscribePriceInfo[symbolId] = {
          symbol: symbolId,
          ...data,
        };
      });
      // 更新价格订阅对象
      this.subscribePriceSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo,
        subscribePriceInfo
      );
      // console.timeLog('CHANGE_SYMBOL_INFO');

      if (needUpdateSymbolInfo) {
        Object.assign(this.symbolInfo, needUpdateSymbolInfo);
        symbolFn(state);
      }
      // console.timeEnd('CHANGE_SYMBOL_INFO');
    },
    // TODO: 取消订阅价格和涨跌幅， 将这些cancel的数据从对象中删除
    CANCEL_SYMBOL_PRICE(data) {
      const list = Array.isArray(data) ? data : [data];
      const subscribePriceSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo
      );
      list.forEach((symbol) => {
        delete subscribePriceSymbolInfo[symbol];
      });

      this.subscribePriceSymbolInfo = subscribePriceSymbolInfo;
    },
    SET_SYMBOL_WALLET(data) {
      this.currentSymbolWallet = {
        walletVO1: data.walletVO1,
        walletVO2: data.walletVO2,
      };
    },
    // 更新当前订单列表交易的类型
    UPDATE_ORDER_TRADE_TAB(payload) {
      this.orderTradeTab = payload;
    },
    // 更新当前订单列表交易的类型
    UPDATE_ORDER_TRADE_TYPE(payload) {
      this.orderTradeType = payload.type;
      this.orderTradePlanType = payload.planType;
    },
    // 设置订单数量
    SET_ORDER_LIST_COUNT(payload) {
      // this.currentOrderCounter[payload.type] = payload.length
      if (payload.type === "spot_margin") {
        this.currentOrderCounter["SPOT_MARKET"] = payload.length;
      } else if (payload.type === "trigger_order") {
        this.currentOrderCounter["SPOT_TRIGGER"] = payload.length;
      } else if (payload.type === "stop_limit") {
        this.currentOrderCounter["SPOT_STOP"] = payload.length;
      }
    },
    // 设置杠杆仓位数量
    SET_MARGIN_ASSETS_POSITIONS_COUNT(payload) {
      this.marginAssetsPositionsCounter = payload;
    },
    // 更新当前委托的配置及数据
    // 配置pending状态
    // 配置数据
    // 配置其他数据
    UPDATE_CURRENT_ORDER({
      pending,
      data,
      config,
      pendingTimeoutID,
      orderMode,
    }) {
      console.log(
        "🚀 ~ file: trade.js:429 ~ UPDATE_CURRENT_ORDER ~ orderMode:",
        orderMode
      );
      // 原来这一处有以下代码，但实际业务代码中未发现有使用到userid的场景
      // 这段代码将较难维护，要兼容新增了userid的情况
      // if (!config.userId && !!this.currentOrder.config.userId) {
      //   this.currentOrder.config.userId = undefined
      // }
      const ORDER_MODE_MAP = {
        [PRO_TRADE_MODE_ENUM.SPOT]: "spot",
        [PRO_TRADE_MODE_ENUM.MARGIN]: "margin",
        [BASIC_TRADE_MODE_ENUM.SPOT]: "spot",
        [BASIC_TRADE_MODE_ENUM.MARGIN]: "margin",
      };

      // 如果当前所显示的交易模式和数据的不一致时，则抛掉数据
      if (
        orderMode > 0 &&
        !(
          this.tradePageLayout === TRADE_PAGE_LAYOUT.PRO &&
          orderMode === ORDER_MODE_MAP[this.proTradeMode]
        ) &&
        !(
          this.tradePageLayout === TRADE_PAGE_LAYOUT.BASIC &&
          orderMode === ORDER_MODE_MAP[this.basicTradeMode]
        )
      )
        return;

      this.currentOrder = {
        config: {
          ...this.currentOrder.config,
          ...config, // 都以最新的值为准
        },
        data: Array.isArray(data) ? data : this.currentOrder.data,
        pending:
          typeof pending === "boolean" ? pending : this.currentOrder.pending,
        pendingTimeoutID,
      };

      if (data && data.length !== 0) {
        const dataLen = data.length;
        const startIndex =
          (this.currentOrder?.config?.pageIndex - 1) *
          this.currentOrder?.config?.pageSize;

        if (dataLen < config?.pageSize) {
          // 已经后面没数据了
          openOrdersOri.splice(
            startIndex,
            openOrdersOri.length - startIndex,
            ...data
          );
        } else {
          openOrdersOri.splice(startIndex, dataLen, ...data);
        }
      }
    },
    // 更新 历史委托的分页配置
    UPDATE_HISTORY_ORDER({
      pending,
      data,
      config,
      pendingTimeoutID,
      orderMode,
    }) {
      const ORDER_MODE_MAP = {
        [PRO_TRADE_MODE_ENUM.SPOT]: 1,
        [PRO_TRADE_MODE_ENUM.MARGIN]: 2,
        [BASIC_TRADE_MODE_ENUM.SPOT]: 1,
        [BASIC_TRADE_MODE_ENUM.MARGIN]: 2,
      };

      // 如果当前所显示的交易模式和数据的不一致时，则抛掉数据
      if (
        orderMode > 0 &&
        !(
          this.tradePageLayout === TRADE_PAGE_LAYOUT.PRO &&
          orderMode === ORDER_MODE_MAP[this.proTradeMode]
        ) &&
        !(
          this.tradePageLayout === TRADE_PAGE_LAYOUT.BASIC &&
          orderMode === ORDER_MODE_MAP[this.basicTradeMode]
        )
      )
        return;

      this.historyOrder = {
        config: {
          ...this.historyOrder.config,
          ...config,
        },
        data: Array.isArray(data) ? data : this.historyOrder.data,
        pending:
          typeof pending === "boolean" ? pending : this.historyOrder.pending,
        pendingTimeoutID,
      };

      if (data && data.length !== 0) {
        const dataLen = data.length;
        const startIndex =
          (this.historyOrder?.config?.pageIndex - 1) *
          this.historyOrder?.config?.pageSize;

        if (dataLen < config?.pageSize) {
          // 已经后面没数据了
          historyOrdersOri.splice(
            startIndex,
            historyOrdersOri.length - startIndex,
            ...data
          );
        } else {
          historyOrdersOri.splice(startIndex, dataLen, ...data);
        }
      }
    },
    UPDATE_COMPLETE_ORDER({ pending, data, config }) {
      if (config) {
        // 这段代码将较难维护，要兼容新增了userid的情况
        if (!config.userId && !!this.completeOrder.config.userId) {
          this.completeOrder.config.userId = undefined;
        }
        // 兼容新增了orderMode的情况
        if (!config.orderMode && !!this.completeOrder.config.orderMode) {
          this.completeOrder.config.orderMode = undefined;
        }
        Object.assign(this.completeOrder.config, config);
      }
      const nextState = {};
      if (Array.isArray(data)) {
        Object.assign(nextState, {
          data,
        });
      }
      if (typeof pending === "boolean") {
        Object.assign(nextState, {
          pending,
        });
      }
      Object.assign(this.completeOrder, nextState);
    },
    // 更新资金列表的配置
    // 配置pending状态
    // 配置数据
    // 配置其他数据
    UPDATE_ASSETS_FUNDS_LIST({
      pending,
      data,
      dataMap,
      config,
      pendingTimeoutID,
    }) {
      this.assetsFundsList = {
        config: {
          ...this.assetsFundsList.config,
          ...config, // 都以最新的值为准
        },
        data: _isArray(data) ? data : this.assetsFundsList.data,
        dataMap: _isObject(dataMap) ? dataMap : this.assetsFundsList.dataMap,
        pending:
          typeof pending === "boolean" ? pending : this.assetsFundsList.pending,
        pendingTimeoutID,
      };
    },
    // 更新仓位列表数据
    UPDATE_ASSETS_POSITIONS_LIST({
      pending,
      data,
      dataMap,
      config,
      pendingTimeoutID,
    }) {
      this.assetsPositionsList = {
        config: {
          ...this.assetsPositionsList.config,
          ...config, // 都以最新的值为准
        },
        data: _isArray(data) ? data : this.assetsPositionsList.data,
        dataMap: _isObject(dataMap)
          ? dataMap
          : this.assetsPositionsList.dataMap,
        pending:
          typeof pending === "boolean"
            ? pending
            : this.assetsPositionsList.pending,
        pendingTimeoutID,
      };
    },
    REMOVE_ORDER_LIST(newItem) {
      const index = this.currentOrder.data.findIndex(
        (obj) => obj.entrustIdStr === newItem.entrustIdStr
      );
      if (index >= 0) {
        this.currentOrder.data.splice(index, 1);
      }
    },
    UPDATE_ORDER_LIST(newItem) {
      this.currentOrder.data.forEach((obj) => {
        if (obj.entrustIdStr === newItem.entrustIdStr) {
          Object.assign(obj, newItem);
        }
      });
    },
    // 增量更新使用
    UPDATE_ASSETS_FUNDS_LIST_ITEM(newItem) {
      this.assetsFundsList.data.forEach((obj) => {
        if (obj.coinType === newItem.coinType) {
          Object.assign(obj, newItem);
        }
      });
    },
    // SET_BUY_INPUT_PRICE(data) {
    //   this.buyPrice = data.price
    // },
    // SET_BUY_INPUT_AMOUNT(data) {
    //   this.buyAmount = data.amount
    // },
    // SET_SELL_INPUT_PRICE(data) {
    //   this.sellPrice = data.price
    // },
    // SET_SELL_INPUT_AMOUNT(data) {
    //   this.sellAmount = data.amount
    // },
    SET_SUBSCRIPTED_PRICE(data) {
      this.hadSubscribedPrice = data.isSub;
      this.subPriceLang = data.lang;
    },
    SET_COININFO(data) {
      const coinInfo = {};
      if (!data || !data.details) {
        coinInfo.hasInfo = false;
      } else {
        coinInfo.hasInfo = true;
        coinInfo.title = get(data, ["details", "coinAbbreviation"]);
        coinInfo.subtitle = get(data, ["details", "coinFullName"]);
        coinInfo.iconUrl = get(data, ["iconUrl"]);
        coinInfo.issueDate = get(data, ["details", "issueDate"], "-");
        coinInfo.issuePrice = get(data, ["details", "issuePrice"], "-");
        coinInfo.circulating = get(data, ["details", "circulating"], "-");
        coinInfo.totalSupply = get(data, ["details", "totalSupply"], "-");
        coinInfo.website = get(data, ["details", "websiteUrl"]);
        coinInfo.whitepaper = get(data, ["details", "whitePaperUrl"]);
        coinInfo.cmcUrl = get(data, ["cmcUrl"]);
        coinInfo.projectDetail = get(data, [
          "details",
          "projectDetailedIntroduction",
        ]);

        if (data.rating && data.rating.levelResult) {
          coinInfo.hasEvaluation = true;
        } else {
          coinInfo.hasEvaluation = false;
        }
        if (data.rating) {
          coinInfo.projectInformation = get(data, ["rating", "description"]);
          coinInfo.projectEvaluation = get(data, ["rating", "levelResult"]);
          coinInfo.projectAnticipation = get(data, ["rating", "anticipation"]);
          coinInfo.pdfUrl = get(data, ["rating", "pdfUrl"]);
          coinInfo.tokenEcoScore = get(data, ["rating", "ecologyScore"]);
          coinInfo.tokenSubjectScore = get(data, ["rating", "subjectScore"]);
          coinInfo.tokenTeamScore = get(data, ["rating", "teamScore"]);
        }
        if (data.ratingScore) {
          coinInfo.hasRating = true;
          coinInfo.ratingScore = get(data, ["ratingScore", "rating"]);
          coinInfo.hypeScore = get(data, ["ratingScore", "hypeScore"]);
          coinInfo.techScore = +get(data, ["ratingScore", "techScore"]);
          coinInfo.teamScore = +get(data, ["ratingScore", "teamScore"]);
        } else {
          coinInfo.hasRating = false;
        }
      }
      this.coinInfo = coinInfo;
    },
    /**
     * 切换交易类型
     */
    UPDATE_ORDER_TYPE(type) {
      this.orderType = type;
    },
    TOP_ORDER_TYPE(type) {
      this.topOrderType = type;
    },
    SET_ISVIP(data) {
      this.isVip = data;
    },
    SET_ISCOUNTING(isCounting) {
      this.isCountdowning = isCounting;
      if (!isCounting) {
        this.upStateMap[this.symbolInfo.symbol] = true;
      }
    },
    SET_COUNTMS(data) {
      this.countMs = data.countMs;
      this.upTime = data.upTime;
    },
    SET_ORDERS_ID(isAllPair) {
      if (isAllPair) {
        this.currentOrder.config.tradeMappingId = null;
        this.historyOrder.config.tradeMappingId = null;
        this.completeOrder.config.tradeMappingId = null;
      } else {
        this.currentOrder.config.tradeMappingId = this.symbolInfo.symbol;
        this.historyOrder.config.tradeMappingId = this.symbolInfo.symbol;
        this.completeOrder.config.tradeMappingId = this.symbolInfo.symbol;
      }
    },
    SET_ALL_PAIR(data) {
      this.isAllPair = data;
    },
    // 新加逻辑，保证最新价格一致
    SET_LAST_PRICE(price) {
      const precision = BigNumber(this.symbolInfo.rate).dp();
      this.symbolInfo.rate = BigNumber(this.symbolInfo.rate)
        .div(this.symbolInfo.c)
        .times(price)
        .toFixed(precision);
      this.symbolInfo.c = price;
      // this.symbolInfo.rate = (data * ratio).toFixed(2)
    },
    // 重置挂单簿单位
    // SET_PENDING_ORDER_COUNT_NEED_RESET (state) {
    //   this.pendingOrderCount.len = 0
    //   this.pendingOrderCount.unit = ''
    //   this.pendingOrderCount.needReset = true
    // },
    // 设置挂单簿单位
    SET_PENDING_ORDER_COUNT_UNIT(data) {
      // 判断是否需要重置数量单位
      if (data.buyList.length === 0 && data.sellList.length === 0) return;

      // 初次加载，获得单位数数据，buyArr和sellArr中找到最大值
      const amountList = [
        ...data.buyList.map((item) => +item.amount),
        ...data.sellList.map((item) => +item.amount),
      ];
      const totalList = [
        ...data.buyList.map((item) => +item.total),
        ...data.sellList.map((item) => +item.total),
      ];
      const maxValue = Math.max(
        Math.max(...amountList),
        Math.max(...totalList)
      );
      // 当前最大值的数值长度，再加上一个单位的长度，以及预留1个补充小数位时的的长度
      const maxValueLen = data.$numbro(maxValue).length + 2;
      const maxLimitLen = data.limit;
      const UNIT_MAP = {
        3: "K",
        6: "M",
        9: "B",
        12: "T",
        15: "P",
        18: "E",
        21: "Z",
        24: "Y",
      };

      const step = 3;
      const count = Math.ceil((maxValueLen - maxLimitLen) / step);

      // console.log(
      //   '最大值maxValue：',
      //   maxValue,
      //   '容器可容纳数量：',
      //   maxLimitLen,
      //   '需缩进单位的数量：',
      //   count * step,
      //   '提到的单位：',
      //   UNIT_MAP[count * step]
      // )

      this.pendingOrderCount.len = count * step;
      this.pendingOrderCount.unit = UNIT_MAP[count * step];
    },
    // 重置市场交易单位
    // SET_MARKET_TRADE_COUNT_NEED_RESET(state) {
    //   this.marketTradeCount.len = 0
    //   this.marketTradeCount.unit = ''
    //   this.marketTradeCount.needReset = true
    // },
    // 设置市场交易单位
    SET_MARKET_TRADE_COUNT_UNIT(data) {
      // 判断是否需要重置数量单位
      if (data.list.length <= 0) return;

      // 初次加载，获得单位数数据，buyArr和sellArr中找到最大值
      const amountList = data.list.map((item) => +item.count);
      const maxValue = Math.max(...amountList);
      // 当前最大值的数值长度，再加上一个单位的长度
      const maxValueLen = data.$numbro(maxValue).length + 1;
      const maxLimitLen = data.limit;
      const UNIT_MAP = {
        3: "K",
        6: "M",
        9: "B",
        12: "T",
        15: "P",
        18: "E",
        21: "Z",
        24: "Y",
      };

      const step = 3;
      const count = Math.ceil((maxValueLen - maxLimitLen) / step);

      this.marketTradeCount.len = count * step + 1;
      this.marketTradeCount.unit = UNIT_MAP[count * step];
    },
    // 设置交易手续费白名单
    SET_FEE_WHITE_LIST(data) {
      this.feeWhiteList = data;
    },
    // 简单起见，不用getter
    SET_PRIVATE_COIN_LIST(_data) {
      if (!privateList) {
        return;
      }
      // 用户所属地区未准备好
      if (!window.currentCountryCode) {
        return;
      }
      privateList = privateList.filter((item) => {
        return item.countrys?.includes(window.currentCountryCode);
      });
      this.privateCoinList = this.privateCoinList.concat(privateList);
      // 开始处理现货交易对 symbolList symbolById
      if (!this.symbolList || isEmpty(this.symbolById)) {
        return;
      }
      privateList.forEach((priItem) => {
        const coinId = priItem.coinId;
        const keys = Object.keys(this.symbolById);
        keys.forEach((symbolId) => {
          if (
            // 买卖币或者计价币
            (+this.symbolById[symbolId].coinId === +coinId ||
              +this.symbolById[symbolId].marketCoinId === +coinId) &&
            !this.privateSymbolList.includes(+symbolId)
          ) {
            this.privateSymbolList.push(+symbolId);
          }
        });
      });
    },
    // 设置专业版交易模式
    SET_PRO_TRADE_MODE(data) {
      this.proTradeMode = data;
    },
    // 设置订阅价格的交易对信息 subscribePriceSymbolInfo
    SET_SUBSCRIBE_PRICE_SYMBOL_INFO(data) {
      this.subscribePriceSymbolInfo = data;
    },
    // 设置普通版交易模式
    SET_BASIC_TRADE_MODE(data) {
      this.basicTradeMode = data;
    },
    // 设置页面类型
    SET_TRADE_PAGE_LAYOUT(data) {
      this.tradePageLayout = data;
    },
    // 设置隐私币列表
    SET_COIN_INVISIBLE_LIST(data) {
      this.coinInvisibleList = data;
    },
    /**
     * 除首页，trade页面，其他页面要用到 state symbolById, 需先判断 isEmpty, then dispatch
     * @param {*}
     * @returns
     */
    async getSymbolList() {
      const indexStore = useIndexStore()

      const ret = await axiosClient({
        url: "/gw-api/ds/web/spot-map",
        method: "GET",
        params: {
          local: transLang(this.getLocaleFromIndex, indexStore),
        },
      });

      if (ret?.success) {
        if (!ret.data.result || ret.data.result.length === 0) {
          console.log("no trade pair");
          return;
        }
        this.SET_SYMBOL_LIST(ret.data.result);
      }
    },
    // 调用ds/map，重新设置symbolList和symbolById，目的是更新价格等信息
    refreshSymbolList() {
      const indexStore = useIndexStore()
      const fetch = process.client ? axiosClient : axiosNuxt;
      fetch({
        url: "/gw-api/ds/web/spot-map",
        method: "GET",
        params: {
          local: transLang(this.getLocaleFromIndex, indexStore),
        },
      }).then((ret) => {
        if (ret?.success) {
          if (!ret.data.result || ret.data.result.length === 0) {
            console.log("no trade pair");
            return;
          }
          this.SET_SYMBOL_LIST(ret.data.result);
        }
      });
    },
    // 交易队改变
    changeSymbol(params) {
      if (+this.symbolInfo.symbolId === +params.symbolId) {
        return;
      }
      const symbolId = String(params.symbolId);
      const symbolEntity = this.symbolById[symbolId];
      // 这里不做老的交易对取消订阅，因为无法确认这个交易对是否在视图中，所以适量冗余
      let querySym;
      if (symbolEntity) {
        const [p, s] = symbolEntity.name.split("/");
        querySym = `${p}_${s}`;
      }
      // 交易对变化，
      // commit('SET_SYMBOLID', symbolId)
      // 中间件处理

      // 如果不存在layout，则取默认的layout和theme值
      const layout = params.layout
        ? params.layout
        : Cookies.get("tradeType") === "pro"
        ? "pro"
        : "basic";
      const theme = params.theme
        ? params.theme
        : Cookies.get("isDayMode") === "true"
        ? "light"
        : "dark";

      const routeParam = {
        // name: 'trade-lang',
        params: { lang: OLD_LOCALES_OBJ_REVERSE[this.getLocaleFromIndex] },
        query: { layout, theme, symbol: querySym },
      };
      // if (this.getLocaleFromIndex === 'en') {
      //   delete routeParam.params
      // }
      // 注意，容易bug ?? store里能用this.$router
      this.$router.replace(routeParam, () => {
        // 在预发布
        if (!this.upStateMap[this.symbolInfo.symbol]) {
          this.SET_ISCOUNTING(true);
          this.getUpState();
        } else {
          this.SET_ISCOUNTING(false);
        }
        this.SET_ORDERS_ID(this.isAllPair);
        // 如果登录了。则做登录之后的action
        if (this.getIsLoginedFromIndex) {
          // 这里要稍微注意一下 后面做杠杆的时候加入了 params参数 这个参数里面可能会包含是否是杠杆切换交易对的信息
          // 原来的逻辑是和刷一下现货委托单，但是如果判断是杠杆页面就不会刷现货委托单，避免和下面的杠杆专门逻辑冲突
          this.loginThen(params);
        }

        // websocketSub.getSubItems()

        // 深度图 默认最高深度
        // const initDepthData = {
        //   code: 0,
        //   data: {
        //     buys: [],
        //     sells: [],
        //   },
        //   subscribe: 'depth',
        //   symbol: +params.symbolId,
        //   precision: this.symbolInfo.currentPrecision.val,
        // }
        // websocketSub.getSocketSub().next(initDepthData) // 为了健壮性这里做了特殊处理

        // cancelSeriesWsItems(websocketSub, 'depth')
        this.$worker.ws.emit("message", {
          type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
          payload: [
            "depth",
            {
              symbol: params.symbolId,
              precision: this.symbolInfo.currentPrecision.val,
            },
          ],
        });
        // this.$worker.ws.subscribe('depth', {
        //   symbol: params.symbolId,
        //   precision: this.symbolInfo.currentPrecision.val,
        // });
        // websocketSub.createSubject({
        //   subscribe: 'depth',
        //   symbol: params.symbolId,
        //   precision: this.symbolInfo.currentPrecision.val,
        // })

        // 市场交易
        // const initTradeData = {
        //   code: 0,
        //   data: {
        //     trades: [],
        //   },
        //   subscribe: 'trade',
        //   symbol: +params.symbolId,
        // }
        // websocketSub.getSocketSub().next(initTradeData) // 为了健壮性这里做了特殊处理

        // cancelSeriesWsItems(websocketSub, 'trade')
        this.$worker.ws.emit("message", {
          type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
          payload: [
            "trade",
            {
              symbol: params.symbolId,
            },
          ],
        });

        // websocketSub.createSubject({
        //   subscribe: 'trade',
        //   symbol: params.symbolId,
        // })

        //切换交易对后的币种查询信息
        this.getCoinInfo();

        // 如果是杠杆就单独做一点杠杆的逻辑,由于杠杆和现货的逻辑和组件有公用的部分，
        // 杠杆页中切换交易对实际上调用的是现货的切换交易对来切换深度和价格啥的，但是委托单组件是不一样的请求，这部分判断是应用于委托单的
        if (params && params.isMargin) {
          this.getCurrentOrder({
            orderMode: 2,
          });
          this.getHistoryOrder({
            orderMode: 2,
          });
          this.getCompleteOrder({
            orderMode: 2,
          });
        }
      });
    },
    /**
     * [getCoinInfo 获取币种查询信息]
     */
    async getCoinInfo() {
      const indexStore = useIndexStore()
      const timestamp = new Date().getTime();
      const params = {
        lang: transLang(this.getLocaleFromIndex, indexStore),
        timestamp,
        type: "TOKEN_INSIGHT",
        coinName: this.symbolInfo.symbolSubName,
      };
      let ret;
      try {
        ret = await axiosClient({
          method: "GET",
          url: "/gw-api/ds/find_coin_details",
          headers: { noMessageList: [3, -3201] },
          params,
        });
      } catch (e) {
        this.SET_COININFO(null);
        console.log(e);
      }

      if (ret && ret?.success && ret.data) {
        if (
          !ret.data.cmcUrl &&
          !ret.data.details &&
          !ret.data.iconUrl &&
          !ret.data.rating &&
          !ret.data.ratingScore
        ) {
          this.SET_COININFO(null);
        } else {
          this.SET_COININFO(ret.data);
        }
      } else {
        this.SET_COININFO(null);
      }
    },

    /**
     * [getSymbolWallet 获取币种余额 V3 新增 替代 user_assets]
     */
    async getSymbolWallet() {
      const lang = this.getLocaleFromIndex;
      const indexStore = useIndexStore()
      const langParam = transLang(lang, indexStore);
      const params = {
        local: langParam,
        symbol: this.symbolInfo.symbolId,
      };

      // 增加函数节流
      if (
        !walletFn ||
        walletSymbol !== this.symbolInfo.symbolId ||
        walletLocale !== langParam
      ) {
        walletSymbol = this.symbolInfo.symbolId;
        walletLocale = langParam;

        walletFn = _debounce(async () => {
          if (!isLoginedToken()) {
            return;
          }
          // const token = Cookies.get("accessToken");

          const ret = await axiosClient({
            url: '/gw-api/asset-gateway/spot/balance/trade',
            method: "get",
            // headers: {
            //   Authorization: token,
            // },
            params,
          });
          if (ret?.success) {
            this.SET_SYMBOL_WALLET(ret.data);
          }
        }, 1000);
        walletFn();
      } else {
        walletFn();
      }
    },
    // 只获取第一页的分页的订单数量
    getCurrentOrderCount(payload) {
      const tempTradeType = payload.planType;
      payload.orderMode = +payload.orderMode === 1 ? "spot" : "iso_margin";
      delete payload.planType;
      delete payload.tradeType;
      delete payload.pageIndex;
      delete payload.pageSize;
      const tradeMappingId = this.currentOrder.config.tradeMappingId;
      let symbol;
      if (tradeMappingId) {
        symbol = this.symbolById[tradeMappingId].name.replace("/", "_");
      }
      return axiosClient({
        method: "post",
        url: "/gw-api/entrust-gateway/client/open-orders",
        headers: {
          "Content-Type": "application/json",
        },
        data: filterFalsityParams(
          {
            _counter: "counter",
            _from: payload._from,
            symbol,
            tradeType: tempTradeType,
            ...this.currentOrder.config, // 其他使用最新的配置项，只有以下3项固定
            limit: 5, // 固定5条
            ...payload,
          },
          true
        ),
      }).then((res) => {
        // 只更新成功的，未成功不替换数据
        if (res?.success) {
          const dataRes = res?.data || [];
          this.SET_ORDER_LIST_COUNT({
            type: tempTradeType,
            length: dataRes.length,
          });
        }
      });
    },
    // 必须将它们分开来，才能分别利用好截流
    getCurrentOrderCountWithDebounceByMarket: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrderCount({
            ...payload,
            orderMode: 1, // 现货相关
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_MARKET,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_MARKET,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getCurrentOrderCountWithDebounceByTrigger: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrderCount({
            ...payload,
            orderMode: 1, // 现货相关
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_TRIGGER,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getCurrentOrderCountWithDebounceByStop: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrderCount({
            ...payload,
            orderMode: 1, // 现货相关
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_STOP,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_STOP,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getCurrentOrderCountDebounce({ dispatch }, payload = {}) {
      if (!payload.tradeType) {
        this.getCurrentOrderCountWithDebounceByMarket(payload);
        this.getCurrentOrderCountWithDebounceByTrigger(payload);
        this.getCurrentOrderCountWithDebounceByStop(payload);
      } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_MARKET) {
        this.getCurrentOrderCountWithDebounceByMarket(payload);
      } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER) {
        this.getCurrentOrderCountWithDebounceByTrigger(payload);
      } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_STOP) {
        this.getCurrentOrderCountWithDebounceByStop(payload);
      }
    },
    /**
     * 查询当前委托
     * 列表更新为第一页时，也会更新计数
     * 不能在这里加debounce，因为数据是只存在了一个字段上
     */
    async getCurrentOrder(
      payload = {}
    ) {
      if (!isLoginedToken()) return;
      // 如果指定了tradaeType，但与当前用户所在的tab对应不上时，则不刷新

      if (
        typeof payload.planType === "string" &&
        payload.planType !== this.orderTradePlanType
      )
        return;
      //   SPOT_MARKET: 'SPOT_MARKET',
      // SPOT_TRIGGER: 'SPOT_TRIGGER',
      // SPOT_STOP: 'SPOT_STOP',
      // MARGIN: 'MARGIN',
      clearTimeout(this.currentOrder.pendingTimeoutID);

      this.UPDATE_CURRENT_ORDER({ pending: true });

      try {
        const { _from, pageIndex, pageSize, ...others } =
          this.currentOrder.config;
        const tempTradeType = ORDER_TRADE_PLAN_TYPE_ENUM[payload.tradeType];
        delete payload.tradeType;
        payload.orderMode = +payload.orderMode === 1 ? "spot" : "iso_margin";
        // 分页参数 从第二页开始要传上一次查询的最后一条记录的pid, 没有以前的current 了
        // list 以后记录所有的记录 ，模拟  load more
        let lastPid = null;
        if (+pageIndex === 1) {
          lastPid = null;
          openOrdersOri = []; // 重置
        } else {
          let lastItem = openOrdersOri[(pageIndex - 1) * pageSize - 1];
          if (!lastItem) {
            lastItem = openOrdersOri[openOrdersOri.length - 1];
          }
          lastPid = lastItem.pid;
        }
        if (others.tradeMappingId) {
          others.symbol = this.symbolById[others.tradeMappingId].name.replace(
            "/",
            "_"
          );
          delete others.tradeMappingId;
        }
        const res = await axiosClient({
          method: "post",
          url: "/gw-api/entrust-gateway/client/open-orders",
          data: filterFalsityParams(
            {
              _from,
              limit: pageSize,
              // current: pageIndex,
              // state: [ENTRUST_STATE.FREEZE_SUCCESS, ENTRUST_STATE.PARTIAL_COMPLETE].join(','),
              // planType: payload.orderMode === 1 ? ORDER_TRADE_PLAN_TYPE_ENUM[tempTradeType] : null,
              tradeType: tempTradeType,
              lastPid,
              ...others,
              ...payload,
            },
            true
          ),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (res?.success) {
          // 不能使用这种写法，他会导致res.data=null时也是一个有值的，而不会被设置为空数组[]
          // const data = get(res, 'data', [])

          const data = res.data || [];

          const updater = {
            orderMode: payload.orderMode,
            config: {
              pageIndex,
              pageSize,
            },
          };

          // 如果当前分页大于1，并且无数据时
          if (data.length === 0 && pageIndex > 1) {
            // 先减1
            Object.assign(updater, {
              config: {
                pageIndex: pageIndex - 1,
                pageSize,
              },
            });

            // 没有更多的数据了
            // 数据为空时，不触发数据的替换，依旧显示pageSize的长度
            if (this.currentOrder.data.length === pageSize) {
              ElMessage({
                message: this.app.i18n.t("common.no_more_logs"),
                type: "warning",
              });
            } else {
              // 下面这个触发不到才对
              this.getCurrentOrder();
            }
          } else {
            Object.assign(updater, {
              data,
            });
          }

          this.UPDATE_CURRENT_ORDER(updater);
          // 如果现货，并且是第一页，还会更新计数
          if (payload?.orderMode === 1 && pageIndex === 1) {
            this.SET_ORDER_LIST_COUNT({
              type: tempTradeType,
              length: data.length,
            });
          }
        } else {
          if (get(res, "code") === -6 && payload.onmessage) {
            payload.onmessage(res);
          }
        }
      } catch (err) {
        // ignore
      } finally {
        // 优化体验
        // 如果是pending false，则期望pending的时间延迟执行，因为这里的可能会有很多请求，直接触发了pending的状态变化
        clearTimeout(this.currentOrder.pendingTimeoutID);

        const pendingTimeoutID = setTimeout(() => {
          this.UPDATE_CURRENT_ORDER({ pending: false });
        }, pendingTimeout);

        this.UPDATE_CURRENT_ORDER({ pendingTimeoutID });
      }
    },
    getCurrentOrderWithDebounceByMargin: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrder({
            ...payload,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getCurrentOrderWithDebounceByMarket: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_MARKET,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_MARKET,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getCurrentOrderWithDebounceByTrigger: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_TRIGGER,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getCurrentOrderWithDebounceByStop: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getCurrentOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_STOP,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_STOP,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getCurrentOrderWithDebounce({ dispatch }, payload = {}) {
      if (payload.orderMode === 1) {
        if (!payload.tradeType) {
          this.getCurrentOrderWithDebounceByMarket(payload);
          this.getCurrentOrderWithDebounceByTrigger(payload);
          this.getCurrentOrderWithDebounceByStop(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_MARKET) {
          this.getCurrentOrderWithDebounceByMarket(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER) {
          this.getCurrentOrderWithDebounceByTrigger(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_STOP) {
          this.getCurrentOrderWithDebounceByStop(payload);
        }
      } else {
        this.getCurrentOrderWithDebounceByMargin(payload);
      }
    },
    /**
     * 查询历史委托
     */
    async getHistoryOrder(payload = {}) {
      if (!isLoginedToken()) return;

      // 如果指定了tradeType，但与当前用户所在的tab对应不上时，则不刷新
      if (
        typeof payload.planType === "string" &&
        payload.planType !== this.orderTradePlanType
      )
        return;

      clearTimeout(this.historyOrder.pendingTimeoutID);

      this.UPDATE_HISTORY_ORDER({ pending: true });

      try {
        const { _from, pageIndex, pageSize, ...others } =
          this.historyOrder.config;
        const tempTradeType = ORDER_TRADE_PLAN_TYPE_ENUM[payload.tradeType];
        delete payload.tradeType;
        payload.orderMode = +payload.orderMode === 1 ? "spot" : "iso_margin";
        // 分页参数 从第二页开始要传上一次查询的最后一条记录的pid, 没有以前的current 了
        // list 以后记录所有的记录 ，模拟  load more
        let lastPid = null;

        if (+pageIndex === 1) {
          lastPid = null;
          historyOrdersOri = []; // 重置
        } else {
          let lastItem = historyOrdersOri[(pageIndex - 1) * pageSize - 1];
          if (!lastItem) {
            lastItem = historyOrdersOri[historyOrdersOri.length - 1];
          }
          lastPid = lastItem.pid;
        }
        if (others.tradeMappingId) {
          others.symbol = this.symbolById[others.tradeMappingId].name.replace(
            "/",
            "_"
          );
          delete others.tradeMappingId;
        }
        const res = await axiosClient({
          method: "post",
          url: "/gw-api/entrust-gateway/client/history-orders",
          data: filterFalsityParams(
            {
              _from,
              limit: pageSize,
              // current: pageIndex,
              // state: [ENTRUST_STATE.FREEZE_SUCCESS, ENTRUST_STATE.PARTIAL_COMPLETE].join(','),
              tradeType: tempTradeType,
              lastPid,
              ...others,
              ...payload,
            },
            true
          ),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (res?.success) {
          const data = res.data || [];
          data.map((obj) => {
            // temp string id
            // tempStr不再维护，后续可删
            obj.entrustIdStr = obj.entrustIdStr || obj.tempStr || obj.entrustId;
          });

          const updater = {
            orderMode: payload.orderMode,
            config: {
              pageIndex,
              pageSize,
            },
          };

          if (data.length === 0 && pageIndex > 1) {
            Object.assign(updater, {
              config: {
                pageIndex: pageIndex - 1,
                pageSize,
              },
            });

            ElMessage({
              message: this.app.i18n.t("common.no_more_logs"),
              type: "warning",
            });
          } else {
            Object.assign(updater, {
              data,
            });
          }

          this.UPDATE_HISTORY_ORDER(updater);
        } else {
          if (get(res, "code") === -6 && payload.onmessage) {
            payload.onmessage(res);
          }
        }
      } catch (err) {
        // ignore
      } finally {
        // 优化体验
        // 如果是pending false，则期望pending的时间延迟执行，因为这里的可能会有很多请求，直接触发了pending的状态变化
        clearTimeout(this.historyOrder.pendingTimeoutID);

        const pendingTimeoutID = setTimeout(() => {
          this.UPDATE_HISTORY_ORDER({ pending: false });
        }, pendingTimeout);

        this.UPDATE_HISTORY_ORDER({ pendingTimeoutID });
      }
    },
    getHistoryOrderWithDebounceByMargin: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getHistoryOrder({
            ...payload,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getHistoryOrderWithDebounceByMarket: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getHistoryOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_MARKET,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_MARKET,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getHistoryOrderWithDebounceByTrigger: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getHistoryOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_TRIGGER,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    getHistoryOrderWithDebounceByStop: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getHistoryOrder({
            ...payload,
            planType: ORDER_TRADE_PLAN_TYPE_ENUM.SPOT_STOP,
            tradeType: ORDER_TRADE_TYPE_ENUM.SPOT_STOP,
          });
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),

    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getHistoryOrderWithDebounce({ dispatch }, payload) {
      if (payload.orderMode === 1) {
        if (!payload.tradeType) {
          this.getHistoryOrderWithDebounceByMarket(payload);
          this.getHistoryOrderWithDebounceByTrigger(payload);
          this.getHistoryOrderWithDebounceByStop(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_MARKET) {
          this.getHistoryOrderWithDebounceByMarket(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_TRIGGER) {
          this.getHistoryOrderWithDebounceByTrigger(payload);
        } else if (payload.tradeType === ORDER_TRADE_TYPE_ENUM.SPOT_STOP) {
          this.getHistoryOrderWithDebounceByStop(payload);
        }
      } else {
        this.getHistoryOrderWithDebounceByMargin(payload);
      }
    },
    /**
     * 查询成交记录
     */
    async getCompleteOrder(payload) {
      if (!isLoginedToken()) {
        return;
      }
      // const token = Cookies.get("accessToken");
      const salt = Cookies.get("accessSalt");
      this.UPDATE_COMPLETE_ORDER({
        pending: true,
      });
      const indexStore = useIndexStore()
      try {
        const local = transLang(this.getLocaleFromIndex, indexStore);
        const { pageIndex, pageSize, ...others } = this.completeOrder.config;
        const params = {
          local,
          timestamp: new Date().getTime(),
          limit: pageSize,
          current: pageIndex,
          ...others,
        };
        if (payload && payload.orderMode) {
          params.orderMode = payload.orderMode;
        }
        insertSignToParams(params, params.timestamp, salt);
        const res = await axiosClient({
          method: "post",
          url: "/gw-api/entrust-gateway/entrustDetailList",
          data: params,
          // headers: {
          //   Authorization: token,
          // },
        });
        if (res?.success) {
          const data = res.data || [];
          data.map((obj) => {
            // tempStr不再维护，后续可删
            obj.entrustIdStr = obj.entrustIdStr || obj.tempStr || obj.entrustId;
          });
          const updater = {};
          if (data.length === 0 && pageIndex > 1) {
            Object.assign(updater, {
              config: {
                pageIndex: pageIndex - 1,
              },
            });
            ElMessage({
              message: this.app.i18n.t("common.no_more_logs"),
              type: "warning",
            });
          } else {
            Object.assign(updater, {
              data,
            });
          }
          this.UPDATE_COMPLETE_ORDER(updater);
        } else {
          if (get(res, "code") === -6 && payload.onmessage) {
            payload.onmessage(res);
          }
        }
      } catch (err) {
        // ignore
      } finally {
        this.UPDATE_COMPLETE_ORDER({
          pending: false,
        });
      }
    },
    /**
     * 查询交易资金列表（现货）
     * 不能在这里加debounce，因为数据是只存在了一个字段上
     */
    async getAssetsFundsList(payload = {}) {
      if (!isLoginedToken()) return;
      // 如果指定了tradeType，但与当前用户所在的tab对应不上时，则不刷新

      clearTimeout(this.assetsFundsList.pendingTimeoutID);

      this.UPDATE_ASSETS_FUNDS_LIST({ pending: true });

      const { _from, ...others } = this.assetsFundsList.config;

      const indexStore = useIndexStore()
      const [res1, res2] = await Promise.all([
        axiosClient({
          method: "GET",
          url: "/gw-api/asset-gateway/asset/coin",
          params: filterFalsityParams(
            {
              _from,
              local: transLang(this.getLocaleFromIndex, indexStore),
              ...others,
              ...payload,
            },
            true
          ),
        }),
        axiosClient({
          method: "GET",
          url: "/gw-api/asset-gateway/spot/balance", //新的钱包接口
          params: filterFalsityParams(
            {
              _from,
              local: transLang(this.getLocaleFromIndex, indexStore),
              ...others,
              ...payload,
            },
            true
          ),
        }),
      ]).finally(() => {
        // 优化体验
        // 如果是pending false，则期望pending的时间延迟执行，因为这里的可能会有很多请求，直接触发了pending的状态变化
        clearTimeout(this.assetsFundsList.pendingTimeoutID);

        const pendingTimeoutID = setTimeout(() => {
          this.UPDATE_ASSETS_FUNDS_LIST({ pending: false });
        }, pendingTimeout);

        this.UPDATE_ASSETS_FUNDS_LIST({ pendingTimeoutID });
      });

      if (!res1?.success || !res2?.success) return;

      // 拼接两个表里的数据
      let assetsCoinList = res1.data?.assetCoinList || [];
      const walletsList = res2.data?.walletList || [];

      const walletMap = walletsList.reduce((map, item) => {
        map[item.coinType] = item;
        return map;
      }, {});

      const assetsCoinMap = assetsCoinList.reduce((map, item) => {
        map[item.coinType] = {
          ...item,
          totalBalance: "0",
          totalLocalBalance: "0",
          availableBalance: "0",
          availableLocalBalance: "0",
          frozenBalance: "0",
          frozenLocalBalance: "0",
          eventFrozenBalance: "0",
          eventFrozenLocalBalance: "0",
          ...walletMap[item.coinType],
        };

        return map;
      }, {});

      // 同时过滤掉无资产的数据
      assetsCoinList = assetsCoinList.map(
        (item) => assetsCoinMap[item.coinType]
      );

      // 按照总资产的USDT进行进行排序
      assetsCoinList.sort((a, b) => {
        return Number(a.totalLocalBalance) >= Number(b.totalLocalBalance)
          ? -1
          : 1;
      });

      this.UPDATE_ASSETS_FUNDS_LIST({
        data: assetsCoinList,
        dataMap: assetsCoinMap,
      });
    },

    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getAssetsFundsListWithDebounce: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getAssetsFundsList(payload);
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    /**
     * 查询交易资金列表（杠杆）
     * 不能在这里加debounce，因为数据是只存在了一个字段上
     */
    async getMarginAssetsFundsList(payload = {}) {
      if (!isLoginedToken()) return;
      // 如果指定了tradeType，但与当前用户所在的tab对应不上时，则不刷新

      clearTimeout(this.assetsFundsList.pendingTimeoutID);

      this.UPDATE_ASSETS_FUNDS_LIST({ pending: true });

      const { _from, ...others } = this.assetsFundsList.config;

      const resData = await axiosClient({
        method: "GET",
        url: "/gw-api/asset-gateway/leverage/balance/coin",
        params: filterFalsityParams(
          {
            _from,
            ...others,
            ...payload,
          },
          true
        ),
      }).finally(() => {
        // 优化体验
        // 如果是pending false，则期望pending的时间延迟执行，因为这里的可能会有很多请求，直接触发了pending的状态变化
        clearTimeout(this.assetsFundsList.pendingTimeoutID);

        const pendingTimeoutID = setTimeout(() => {
          this.UPDATE_ASSETS_FUNDS_LIST({ pending: false });
        }, pendingTimeout);

        this.UPDATE_ASSETS_FUNDS_LIST({ pendingTimeoutID });
      });

      if (!resData?.success) return;

      // 拼接两个表里的数据
      const assetsCoinList = resData.data?.list;

      this.UPDATE_ASSETS_FUNDS_LIST({
        data: assetsCoinList,
        dataMap: {},
      });
    },

    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getMarginAssetsFundsListWithDebounce: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getMarginAssetsFundsList(payload);
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    /**
     * 查询交易仓位列表（杠杆）
     * 不能在这里加debounce，因为数据是只存在了一个字段上
     */
    async getMarginAssetsPositionsList(
      payload = {}
    ) {
      if (!isLoginedToken()) return;
      // 如果指定了tradeType，但与当前用户所在的tab对应不上时，则不刷新

      clearTimeout(this.assetsPositionsList.pendingTimeoutID);

      this.UPDATE_ASSETS_POSITIONS_LIST({ pending: true });

      const { _from, ...others } = this.assetsPositionsList.config;

      const resData = await axiosClient({
        method: "GET",
        url: "/gw-api/asset-gateway/leverage/balance/position",
        params: filterFalsityParams(
          {
            _from,
            ...others,
            ...payload,
          },
          true
        ),
      }).finally(() => {
        // 优化体验
        // 如果是pending false，则期望pending的时间延迟执行，因为这里的可能会有很多请求，直接触发了pending的状态变化
        clearTimeout(this.assetsPositionsList.pendingTimeoutID);

        const pendingTimeoutID = setTimeout(() => {
          this.UPDATE_ASSETS_POSITIONS_LIST({ pending: false });
        }, pendingTimeout);

        this.UPDATE_ASSETS_POSITIONS_LIST({ pendingTimeoutID });
      });

      if (!resData?.success) return;

      // 拼接两个表里的数据

      const assetsPositionsList = (resData.data?.list || []).filter((item) => {
        return +item.baseCoinPosition !== 0 || +item.priceCoinPosition !== 0;
      });

      this.UPDATE_ASSETS_POSITIONS_LIST({
        data: assetsPositionsList,
        dataMap: {},
      });

      this.SET_MARGIN_ASSETS_POSITIONS_COUNT(assetsPositionsList.length);
    },

    // 延迟500ms拉取数据，ws数据推送可能会有延迟
    getMarginAssetsPositionsListWithDebounce: _debounce(
      ({ dispatch }, payload) => {
        // 延迟500ms拉取数据，ws数据推送可能会有延迟
        setTimeout(() => {
          this.getMarginAssetsPositionsList(payload);
        }, wsTimeout);
      },
      debounceTimeout,
      {
        leading: true,
        trailing: false,
        maxWait: debounceTimeout, // 最多也阻止1s
      }
    ),
    /**
     * [cancelOrder 取消委托单]
     * // 目前这里还有被多处调用，暂不优化
     * @param  {[type]} payload   [payload.id 委托单id payload.successCb 成功回调]
     */
    async cancelOrder(payload) {
      if (!isLoginedToken()) return;

      const { id, orderModeCode, successCb, errorCb, ...others } = payload;

      const ret = await axiosClient({
        url: "/gw-api/order/spot/cancel",
        method: "POST",
        data: filterFalsityParams(
          {
            orderId: id,
            reqSource: 2,
            orderModeCode: orderModeCode,
            ...others,
          },
          true
        ),
      });
      if (ret?.success) {
        if (successCb) {
          successCb(payload);
        }
      } else {
        errorCb(ret?.msg);
      }
    },

    /**
     * [loginThen 交易页登录之后，产生的动作]
     * @param  {[type]} payload   [description]
     */
    loginThen(payload) {
      // 获取余额

      this.getSymbolWallet();
      if (!(payload && payload.isMargin)) {
        this.getCurrentOrder();
        this.getHistoryOrder();
      }
      // dispatch('getCompleteOrder');
    },

    /**
     * [subscribeAllCoin 订阅所有币种实时价格 会存到 this.trade.symbolList]
     * [注意this.trade.hadSubscribedPrice 这个状态]
     * @param  {[type]} state     [description]
     * @param  {[type]} commit    [description]
     * @param  {[type]} rootState [description]
     * @param  {[type]} payload   [description]
     * @return {[type]}           [description]
     */
    subscribeAllCoin() {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }

      this.SET_SUBSCRIPTED_PRICE({
        isSub: true,
        lang: unPriceList.includes(this.getLocaleFromIndex) ? "en" : this.getLocaleFromIndex,
      });

      // cancelSeriesWsItems(websocketSub, 'priceBatch')
      const indexStore = useIndexStore()
      const local = unPriceList.includes(this.getLocaleFromIndex)
        ? "en_US"
        : transLang(this.getLocaleFromIndex, indexStore);

      // 订阅所有行情数据
      // priceBatch 后端文档中没有，属于前端冗余字段，为了保持格式一致，不影响功能
      // https://bitmart.atlassian.net/wiki/spaces/DEVELOPMEN/pages/1924595823/WS
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
        payload: [
          "priceBatch",
          {
            event: "addChannel",
            parameters: { type: "all_ticker", sign: local },
          },
        ],
      });

      // websocketSub.createSubject({
      //   subscribe: 'priceBatch',
      //   event: 'addChannel',
      //   parameters: { type: 'all_ticker', sign: local },
      // })

      // const priSubject = websocketSub
      //   .getSocketSub()
      //   .pipe(
      //     delayWhen(() => idle(10000)),
      //     filter(ev => ev.subscribe === 'price' && ev.local === local),
      //     filter(ev => {
      //       const symbolEntity = state.symbolById[String(ev.symbol)];
      //       if (symbolEntity && ev.data) {
      //         if (
      //           symbolEntity.c !== ev.data.c ||
      //           symbolEntity.l !== ev.data.l ||
      //           symbolEntity.h !== ev.data.h ||
      //           symbolEntity.rate !== ev.data.rate ||
      //           symbolEntity.sign !== ev.data.sign ||
      //           symbolEntity.v !== ev.data.v ||
      //           symbolEntity.fluctuation !== ev.data.fluctuation ||
      //           symbolEntity.o !== ev.data.o
      //         ) {
      //           return true;
      //         }
      //       }
      //       return false
      //     }),
      //     map(ev => ({
      //       data: ev.data,
      //       symbolId: ev.symbol,
      //     })),
      //     // 每 0.5s 更新一次
      //     bufferTime(500, null),
      //   );

      // priSubject.subscribe(bufferList => {
      //   if (bufferList.length > 0) {
      //     commit('CHANGE_SYMBOL_INFO', bufferList)
      //   }
      // }, e => console.log(e))
    },

    /**
     * 订阅多个币种实时价格，单币种订阅也适用，只是传入的是[单个币种id]
     * @param {*} param0
     * @param {*} payload
     * @description payload.symbolIds 为多个币种id，['53', '1012']
     * @description payload.unSymbolIds 非必传，为要取消订阅的多个币种id，如果传了，会跟 symbolIds 做对比，订阅新增部分，取消订阅删除部分
     * @description payload.skipCurSymbol 非必传，为 true 时，会跳过当前币种，不去发起订阅/取消订阅
     * @returns
     */
    subscribeCoins(payload) {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }
      if (
        !payload ||
        !Array.isArray(payload.symbolIds) ||
        payload.symbolIds.length === 0
      ) {
        console.log("no symbolIds");
        return;
      }
      const { symbolIds, unSymbolIds } = payload;
      let addSymbolIds = symbolIds;
      let delSymbolIds = [];
      // 如果传了 unSymbolIds，就要做对比，订阅新增部分，取消订阅删除部分
      if (unSymbolIds) {
        addSymbolIds = symbolIds.filter((id) => !unSymbolIds.includes(id));
        delSymbolIds = unSymbolIds.filter((id) => !symbolIds.includes(id));
        // 如果skipCurSymbol为true，就跳过this.trade.symbolInfo.symbol
        if (payload.skipCurSymbol && this.symbolInfo?.symbol) {
          addSymbolIds = addSymbolIds.filter(
            (id) => id !== this.symbolInfo.symbol
          );
          delSymbolIds = delSymbolIds.filter(
            (id) => id !== this.symbolInfo.symbol
          );
        }
      }

      // 如果delSymbolIds有值，就取消订阅
      if (delSymbolIds.length > 0) {
        this.unsubscribeCoins({ symbolIds: delSymbolIds });
      }

      if (addSymbolIds.length === 0) {
        return;
      }
      // 修改store的subscribePriceSymbolInfo
      const subscribeSymbolInfo = Object.assign(
        {},
        this.subscribePriceSymbolInfo
      );
      // 即将做最后一次过滤
      const finalAddSymbolIds = [];
      addSymbolIds.forEach((id) => {
        if (!subscribeSymbolInfo[id]) {
          // 如果没有订阅过，就添加到subscribeSymbolInfo，同时添加到finalAddSymbolIds
          subscribeSymbolInfo[id] = {};
          finalAddSymbolIds.push(id);
        } else if (!subscribeSymbolInfo[id]?.c) {
          // 如果已经在symbolInfo里了，但是没有c值，就添加到finalAddSymbolIds
          // 进入这个流程的应该是重试订阅的流程
          finalAddSymbolIds.push(id);
        }
      });
      if (finalAddSymbolIds.length === 0) {
        return;
      }
      this.SET_SUBSCRIBE_PRICE_SYMBOL_INFO(subscribeSymbolInfo);
      const indexStore = useIndexStore()
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("SUBSCRIBE"),
        payload: [
          "price_batch",
          {
            symbol: finalAddSymbolIds.join(","),
            local: transLang(this.getLocaleFromIndex, indexStore),
          },
          false,
        ],
      });
    },

    // 取消订阅多个币种实时价格, 单币种取消订阅也适用，只是传入的是[单个币种id]
    unsubscribeCoins(payload) {
      if (!this.symbolList || this.symbolList.length === 0) {
        console.log("no trade pair");
        return;
      }
      if (
        !payload ||
        !Array.isArray(payload.symbolIds) ||
        payload.symbolIds.length === 0
      ) {
        console.log("no symbolIds");
        return;
      }
      const { symbolIds } = payload;
      this.CANCEL_SYMBOL_PRICE(symbolIds);
      const indexStore = useIndexStore()
      this.$worker.ws.emit("message", {
        type: WORKER_MSG_TOPIC.get("UNSUBSCRIBE"),
        payload: [
          "price_batch",
          {
            symbol: symbolIds.join(","),
            local: transLang(this.getLocaleFromIndex, indexStore),
          },
          true,
        ],
      });
    },

    // 取消当前所有价格订阅
    unsubscribeAllCoin() {
      const symbolIds = Object.keys(this.subscribePriceSymbolInfo);
      if (symbolIds.length === 0) {
        return;
      }
      this.unsubscribeCoins({ symbolIds });
    },

    // 检查后端返回的当前订阅列表，和前端的订阅列表是否一致，有缺失需要补发一次订阅
    checkSubscribeSymbol(payload) {
      if (!payload?.currentSymbols || !Array.isArray(payload.currentSymbols)) {
        return;
      }
      const { currentSymbols } = payload;
      const subscribeSymbolIds = Object.keys(this.subscribePriceSymbolInfo);
      const diffSymbolIds = subscribeSymbolIds.filter(
        (id) => !currentSymbols.includes(String(id))
      );
      if (diffSymbolIds.length > 0) {
        // console.log('checkSubscribeSymbol', diffSymbolIds)
        this.subscribeCoins({ symbolIds: diffSymbolIds });
      }
    },

    // 判断当前币种是否已开发交易
    async getUpState() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/up-state",
        params: {
          symbolId: this.symbolInfo.symbol,
        },
      });

      if (ret?.success) {
        this.upTime = ret.data.upTime;
        this.serverTime = ret.data.serverTime;

        // 可开放时间时小于服务器时间时
        // 已开放交易
        if (ret.data.upTime - ret.data.serverTime <= 0) {
          this.SET_ISCOUNTING(false);
          this.SET_COUNTMS({
            upTime: 0,
            countMs: 0,
          });
        } else {
          this.SET_COUNTMS({
            upTime: ret.data.upTime,
            countMs: (ret.data.upTime - ret.data.serverTime) * 1000,
          });
          this.SET_ISCOUNTING(true);
          // 看看是否为白名单
          this.getVipMember();
        }
      }
    },

    async getVipMember() {
      if (!isLoginedToken()) {
        return;
      }
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/up-member",
        params: {
          symbolId: this.symbolInfo.symbol,
        },
        // headers: {
        //   Authorization: Cookies.get("accessToken"),
        // },
      });

      if (ret?.success && ret.data.upMember) {
        this.SET_ISVIP(true);
      } else {
        this.SET_ISVIP(false);
      }
    },

    // 获取交易页面费用显示白名单
    async getTradeFeeWhiteList() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/user-center/settings/communal/forbidden/country/get",
        params: {
          bizType: "fee:display:whitelist",
        },
      });

      if (ret?.success) {
        this.SET_FEE_WHITE_LIST(ret?.data?.countryList || []);
      }
    },
    async getPrivateList() {
      const ret = await axiosClient({
        method: "GET",
        url: "/gw-api/ds/find_coin_invisible",
      });

      if (ret?.success) {
        this.SET_COIN_INVISIBLE_LIST(ret?.data?.list || []);
        privateList = ret?.data?.list || [];
        this.SET_PRIVATE_COIN_LIST(privateList);
      }
    },
  },
});
